var _circle, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcHoldAvgColorfulDark = function SvgIcHoldAvgColorfulDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#444040"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10.5,
    width: 15,
    height: 16,
    rx: 2,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.473 22.5h-1.141v-3.906H16v-.758c.352-.016.598-.04.738-.07.224-.05.407-.149.547-.297a.979.979 0 0 0 .219-.407.93.93 0 0 0 .043-.226h.926V22.5Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v2H10v-2Z",
    fill: "#FF8282"
  })));
};
export default SvgIcHoldAvgColorfulDark;